export default __webpack_public_path__ + "static/media/comic.aea952f0.jpg";